import { createStore } from 'satcheljs';
import ScheduleGenerationEditorStateSchema from './schema/ScheduleGenerationEditorStateSchema';
// Register orchestrators (side-effect imports)
import '../orchestrators/onCancelSmartScheduleGenerationJob';
import '../orchestrators/onSelectSmartScheduleGroup';

const initialScheduleGenerationEditorState: ScheduleGenerationEditorStateSchema = {
    isAutoSchedulePanelOpen: false,
    isAddShiftBlockPanelOpen: false,
    selectedGroupId: undefined,
    shiftInEdit: undefined,
    shiftBlocks: [],
    shiftBlocksSnapshot: "[]" // Initialize snapshot to empty array to match initial shiftBlocks
};

const scheduleGenerationEditorState = createStore(
    'scheduleGenerationEditorState',
    initialScheduleGenerationEditorState
);

export { scheduleGenerationEditorState };